import type { ReactNode } from 'react'
import useRightPanelState from './useRightPanelState'
import { RightPanelContext, RightPanelHopTimusContext, RightPanelNotificationsContext } from './rightPanelContext'

interface RightPanelProviderProps {
  children: ReactNode
}

const RightPanelProvider = ({ children }: RightPanelProviderProps) => {
  const { panel, notifications, hopTimus } = useRightPanelState()

  return (
    <RightPanelContext.Provider value={panel}>
      <RightPanelNotificationsContext.Provider value={notifications}>
        <RightPanelHopTimusContext.Provider value={hopTimus}>{children}</RightPanelHopTimusContext.Provider>
      </RightPanelNotificationsContext.Provider>
    </RightPanelContext.Provider>
  )
}

export default RightPanelProvider
